import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function EllipsisInCircleIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'PrimaryDefault', secondaryColor = 'White', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    const secondaryFillColor = themeContext.colors[secondaryColor];
    return (_jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [_jsx("circle", { cx: 12, cy: 12, r: 11, fill: primaryFillColor }), _jsx("circle", { cx: 5.778, cy: 12.23, r: 1.778, fill: secondaryFillColor }), _jsx("circle", { cx: 12, cy: 12.23, r: 1.778, fill: secondaryFillColor }), _jsx("circle", { cx: 18.222, cy: 12.23, r: 1.778, fill: secondaryFillColor })] }));
}
//# sourceMappingURL=EllipsisInCircle.js.map